<template>
  <div class="inlineStar">
    <img v-for="(v, index) in starList" :src="chooseImg(v)" alt="" :key="'rate' + index">
  </div>
</template>

<script>
export default {
  props:{
    starValue: {
      type:Number,
      default: 5
    }
  },
  data () {
    return {
    }
  },
  computed : {
    starList () {
      const list = []
      const value = (this.starValue == 4.9  ? 5 : this.starValue)
      for(let n  = 0; n < Math.floor(value); n ++) {
        list.push('full')
      }
      if ((value+'').indexOf('.') > -1) {
        list.push('half')
      }
      for (let e = 0; e < 5 - Math.ceil(value); e++) {
        list.push('empty')
      }
      return list
    }
  },
  methods: {
    chooseImg(v) {
      return v == 'full' ? require('@/assets/images/full_star.png') :
        v == 'half' ? require('@/assets/images/half_star.png') :
          require('@/assets/images/empty_star.png')
    }
  }
}
</script>

<style lang="scss" scoped>
.inlineStar {
  display: flex;
  align-items: center;
  img {
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
}
</style>
